import React, { useState, useEffect } from "react";
import Banner_slider from "../element/component/Banner_New_Slider";
import Header from "../layout/headerHome";
import Footer from "../layout/footerUpdated";
import { Helmet } from "react-helmet";
import ReachToUsForm from "../element/component/ApplyNowxxForm";
import Popup_Main from "../element/component/Popup_Main";

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 2,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: "15%",
  autoplay: true,
  autoplaySpeed: 3000,
  prevArrow: (
    <div className="slick-prev">
      <i className="fa fa-angle-left" aria-hidden="true"></i>
    </div>
  ),
  nextArrow: (
    <div className="slick-next">
      <i className="fa fa-angle-right" aria-hidden="true"></i>
    </div>
  ),
};

const slides = [
  {
    desktop: "/images/new-website/career/career-1.webp",
    mobile: "/images/new-website/career/career-1.webp",
  },
  {
    desktop: "/images/new-website/career/career-2.webp",
    mobile: "/images/new-website/career/career-2.webp",
  },
  {
    desktop: "/images/new-website/career/career-3.webp",
    mobile: "/images/new-website/career/career-3.webp",
  },
  {
    desktop: "/images/new-website/career/career-4.webp",
    mobile: "/images/new-website/career/career-4.webp",
  },
];

const aboutbg = require("./../../assets/images/shape/car1.webp");

const Career = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [jobs, setJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    document.title = "Career | Bridge Health";
    fetchJobs();
  }, []);

  const fetchJobs = () => {
    const siteUrl = `https://admin.bridgehealth.in`;

    fetch(`${siteUrl}/api/create-jobs`)
      .then((response) => response.json())
      .then((data) => {
        const jobs = data.data.map((job) => ({
          ...job.attributes,
          id: job.id,
        }));
        const sortedJobs = jobs.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setJobs(sortedJobs);
        setFilteredJobs(sortedJobs);
      })
      .catch((error) => {
        console.error("Error fetching jobs:", error);
      });
  };

  const filterJobs = () => {
    try {
      const filtered = jobs.filter((job) => {
        const jobFields = [
          job.designation.toLowerCase(),
          job.department.toLowerCase(),
          job.location.toLowerCase(),
          job.contract_type.toLowerCase(),
        ];

        const searchTermMatch = jobFields.some((field) =>
          field.includes(searchTerm.toLowerCase())
        );

        const departmentMatch =
          selectedDepartment === "" ||
          job.department.toLowerCase() === selectedDepartment.toLowerCase();

        return searchTermMatch && departmentMatch;
      });

      setFilteredJobs(filtered);
    } catch (error) {
      console.error("Error during filtering:", error);
    }
  };

  useEffect(() => {
    filterJobs();
  }, [searchTerm, selectedDepartment]);

  return (
    <>
      <Header />
      <Helmet>
        <title>
          Join Our Team | Career Opportunities | Jobs at Bridge Health
        </title>
        <meta
          name="description"
          content="Explore exciting career opportunities at Bridge Health. Join our dynamic team and contribute to improving lives through innovative healthcare solutions."
        />
      </Helmet>

      <section className="careers-hero">
        <div className="careers-container">
          <h1 className="careers-heading">
            Join Our Team And <br />
            <span className="highlight">Build The Future</span> Together
          </h1>
          <p className="careers-subheading">
            Be part of an innovative team that is transforming the way businesses operate
            with smart, seamless, and future-ready solutions
          </p>
          <a href="#career" className="careers-button">Apply Now</a>

          <div
            className="careers-image-bg"
            style={{ backgroundImage: `url(${aboutbg})` }}
          ></div>
        </div>
      </section>

      <section className="auto-container marginTop50 career-head1 marginTop40reverse" id="career">
        <div className="careers-container-current">
          <h2 className="careers-heading">
            Current <span className="highlight">Openings</span>
          </h2>
        </div>
        {filteredJobs.map((job, index) => (
          <div className="job-card" key={index}>
            <div className="job-card-header">
              <div>
                <span className="job-title">{job.designation}</span>
                <span className="job-department">
                  <span className="fontweight">Dept:</span> {job.department}
                </span>
              </div>
              <div className="careerpadding">
                <span className="job-location">
                  <img
                    srcSet={require("../../assets/images/shape/iconmap.webp")}
                    alt="mapicon"
                    className="padeight"
                    rel="preload"
                  />
                  {job.location}
                  <span>
                    {" "}
                    <img
                      srcSet={require("../../assets/images/shape/dash.webp")}
                      alt="dash"
                      className="dash"
                      rel="preload"
                    />
                  </span>
                </span>
                <span className="job-timing">
                  <img
                    srcSet={require("../../assets/images/shape/icontime.webp")}
                    alt="time"
                    className="padeight"
                    rel="preload"
                  />{" "}
                  {job.contract_type}
                </span>
                <span className="job-department">
                  <button
                    type="button"
                    className="career-popup-btn"
                    title="Apply Now"
                    onClick={() => setIsOpen(true)}
                  >
                    Apply Now
                  </button>
                </span>
              </div>
              <div className="job-card-footer">
                <a
                  href={`/job-description/${job.id}`}
                  className="view-position"
                  title="View Position"
                >
                  View Position &#8594;
                </a>
              </div>
            </div>
          </div>
        ))}
      </section>
{/* 
      <div className="text-align-center">
         <button
                    type="button"
                    className="career-popup-btn"
                    title="Apply Now"
                    onClick={() => setIsOpen(true)}
                  >
                    Apply Now
                  </button>
      </div> */}

      <section className="careers-hero-why">
        <div className="careers-container">
          <h2 className="careers-heading">
            Why <span className="highlight">Work With</span> Us?
          </h2>
        </div>
        <div className="career-why">
          <div className="career-why-details">
            <img src="/images/new-website/career/creative-Culture.webp" />
            <h3>Innovative Culture</h3>
            <p>We value new ideas and innovation, and help your creativity and love for technology grow.</p>
          </div>
          <div className="career-why-details">
            <img src="/images/new-website/career/achievement.webp" />
            <h3>Growth Opportunities</h3>
            <p>We support your growth through learning, mentorship, and a clear path to success.</p>
          </div>
          <div className="career-why-details">
            <img src="/images/new-website/career/team.webp" />
            <h3>Impactful Work</h3>
            <p>Your work makes a real difference and helps create results that improve industries.</p>
          </div>
        </div>
      </section>

      <div className="auto-container-life">
        <div className="row align-items-center">
          <div className="col-lg-12">
            <div className="contact-form-area">
              <div className="sec-title">
                <h2 className="careers-heading">
                  Life at <span className="highlight">Bridge Health</span>
                </h2>
                <p className="font-life">
                  Experience a fulfilling and inclusive life at Bridge Health.
                  Our collaborative culture fosters teamwork and a sense of
                  belonging. From engaging activities to professional
                  development opportunities, we prioritize your well-being and
                  growth. Join our community dedicated to work-life balance
                  and making a meaningful impact in the preventive healthcare
                  industry.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="banner-slider-about">
        <Banner_slider sliderSettings={sliderSettings} slides={slides} />
      </section>

      <Popup_Main isOpen={isOpen} onClose={() => setIsOpen(false)}>
        <ReachToUsForm submitted={() => setIsOpen(false)} />
      </Popup_Main>

      <Footer />
    </>
  );
};

export default Career;
